// @flow
import type {ApplicationRedux} from 'redux/ApplicationRedux';

import {composeWithDevTools} from '@redux-devtools/extension';
import {createAsyncMiddleware} from '@travel-frontend/state-handling-sdk';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';

import {googleTagManagerMiddleware} from 'redux/middleware/googleTagManager';
import {reducer} from 'redux/reducer';

// $FlowFixMe
export function configureStore() {
  const middlewares = applyMiddleware(
    thunk,
    createAsyncMiddleware,
    googleTagManagerMiddleware
  );

  // $FlowFixMe
  return createStore<ApplicationRedux, any, any>(
    reducer,
    process.env.STAGE === 'prod'
      ? middlewares
      : composeWithDevTools(middlewares)
  );
}
